import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
export type QuizSubmissionDTO = {
questionId:string;
answer:string;
};
type quizDetails = {
    score:number;
    status:string;
    num_tries:number;
    question:Question[]
}
type Question = {
    question:string;
    explanation:string
}
export type EssayQuizResponse = {
    quizTitle:string;
    quizDetails:quizDetails
    count:number;
} & ApiError;
export const SubmitEssayQuiz = (
    quizId: string,
    submissions: QuizSubmissionDTO[]
): Promise<EssayQuizResponse> => {
    return axios.post(`/essay/submitEssay/${quizId}`, submissions);
};
